import { useCallback, useMemo } from 'react'
import { Rocket } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchRolloutStatus, FF_STR as S, type RolloutStatusRow } from './featureFlagsApi'

/**
 * A14.15 — Klientga tarqatish holati (client rollout status). Har flag/config
 * kaliti uchun rollout% + platforma + holat. REAL manba `GET /admin/settings/flags`
 * (rollout% qiymatdan hosil qilinadi); segment-platforma alohida endpoint →
 * "all". Read-only, AUDIT_VIEW-gated.
 */
export function RolloutStatus() {
  const columns = useMemo<AdminColumn<RolloutStatusRow>[]>(
    () => [
      {
        key: 'key',
        header: S.key,
        type: 'text',
        minWidth: 260,
        render: (r) => <span className="font-mono text-sm text-primary">{r.key}</span>,
      },
      {
        key: 'rollout_pct',
        header: S.rolloutPct,
        type: 'number',
        width: 180,
        accessor: (r) => r.rollout_pct,
        render: (r) => (
          <div className="flex items-center gap-2">
            <div className="h-2 w-24 overflow-hidden rounded bg-surface-3">
              <div className="h-full rounded bg-accent" style={{ width: `${r.rollout_pct}%` }} />
            </div>
            <span className="w-10 text-right text-xs tabular-nums text-tertiary">{r.rollout_pct}%</span>
          </div>
        ),
      },
      {
        key: 'platforms',
        header: S.platforms,
        type: 'text',
        width: 140,
        render: (r) => <span className="text-xs text-secondary">{r.platforms}</span>,
      },
      {
        key: 'status',
        header: S.status,
        type: 'enum',
        width: 160,
        accessor: (r) => r.status,
        options: [
          { value: 'full', label: S.stFull, status: 'active' },
          { value: 'rolling', label: S.stRolling, status: 'pending' },
          { value: 'off', label: S.stOff, status: 'deleted' },
        ],
      },
      { key: 'updated_at', header: S.updated, type: 'date', width: 160 },
    ],
    [],
  )

  const fetcher = useCallback(fetchRolloutStatus, [])

  return (
    <>
      <PageHeader title={S.rolloutTitle} screenId="A14.15" />
      <DataTable<RolloutStatusRow>
        screenId="A14.15"
        permission={PERMISSIONS.AUDIT_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.key}
        exportable
        emptyState={{ icon: <Rocket size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
